import { render, staticRenderFns } from "./company-information.vue?vue&type=template&id=5fdd22bd&scoped=true&"
import script from "./company-information.vue?vue&type=script&lang=js&"
export * from "./company-information.vue?vue&type=script&lang=js&"
import style0 from "./company-information.vue?vue&type=style&index=0&id=5fdd22bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd22bd",
  null
  
)

export default component.exports